import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const StockInPending = () => {
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, token, logout } = useAuth();

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchData('StockTransferApi', `/${id}`, token)
            .then(r => {
                if (r.responseCode === '1111') {
                    console.log('StockTransfer fields:', r.response_data.StockTransfer);
                    setFormData(r.response_data.StockTransfer);
                    setInvoicedeatils(r.response_data.StockTransferDetails);
                }
            }).catch(console.error);
    }, [id]);

    const fmt = (d) => { if (!d) return ''; const dt = new Date(d); return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`; };
    const fmtVal = (v) => v != null ? parseFloat(v).toFixed(2) : '0.00';

    return (
        <Fragment>
            <div className="pg-container">
                <div className="pg-header">
                    <h5 className="pg-title">Stock Transfer Out - Details</h5>
                    <div className="pg-header-actions">
                        <Link to="/StockIn" className="pg-btn pg-btn-danger"><CloseIcon /> Back to List</Link>
                    </div>
                </div>

                <div className="pg-card">
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">To Branch</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.ToBranchName || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date" value={fmt(formData.BillDate)} disabled />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead><tr><th>#</th><th>Item Name</th><th className="right">Qty</th><th className="right">Rate</th><th className="right">Amount</th></tr></thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items found.</td></tr>
                                    : invoicedeatils.map((item, i) => (
                                        <tr key={i}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{i + 1}</td>
                                            <td>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{fmtVal(item.Rate)}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{fmtVal(item.TotalAmount)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.Remarks || ''} readOnly />
                        </div>
                        {[['Amount', 'TaxableAmount'], ['CGST', 'CGSTAmount'], ['SGST', 'SGSTAmount'], ['IGST', 'IGSTAmount'], ['Round Off', 'RoundOff'], ['Grand Total', 'GrandTotal']].map(([label, key]) => (
                            <div key={key} className="pg-hcell" style={{ flex: '1 1 0' }}>
                                <span className="pg-hcell-label">{label}</span>
                                <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={fmtVal(formData[key])} readOnly />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default StockInPending;
